import React, { ReactNode, FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { ReactComponent as WarningIcon } from '../../../icons/warning.svg';
import { MessageProps } from '../Message/Message';
import { StyledMessage } from './WarningMessage.styles';

export interface WarningMessageProps extends MessageProps {
  /** Custom warning message. */
  children?: ReactNode;
  /** The warning message title. */
  warningTitle?: string;
  /** Alias for `warningTitle`. */
  messageTitle?: string;
}

const WarningMessage: FC<WarningMessageProps> = ({ children, warningTitle, ...props }) => {
  const theme = useContext(ThemeContext);
  return (
    <StyledMessage
      role="alert"
      messageTitle={warningTitle}
      iconColor={theme.colors.warning}
      {...props}
      Icon={WarningIcon}
    >
      {children}
    </StyledMessage>
  );
};

export default WarningMessage;
